import { Form, Formik } from "formik";
import AutoFocusError from "../components/AutoFocusError";
import { SellerStep1Schema } from "../validations";
import * as Yup from "yup";
import { useState } from "react";
import axios from "axios";
import { useLocation } from "react-router";
import { config } from "../utils/config";
import FormFirstSlide from "../components/FormFirstSlide";
import StartSellingHomeForm from "./StartSellingHomeForm";
import StartBuyingHomeForm from "./StartBuyingHomeForm";
import LeadReferralRewardsGenericForm from "./LeadReferralGenericForm";
import HomeToRentGenericForm from "./HomeToRentGenericForm";

const MultipleSelectionForm = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const [currentStep, setCurrentStep] = useState(1);
  const [isWhatsApp, setIsWhatsApp] = useState(false);
  const [phoneBtnClick, setPhoneBtnClick] = useState(false);
  const [submitError, setSubmitError] = useState(false);
  const [userType, setUserType] = useState("");
  const windowUrl = window.location.href;

  const userAddress = queryParams.get("address");
  const marketingSource = queryParams.get("source");
  const initialValues = {
    name: "",
    email: "",
    phone: "",
    category: "",
  };

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    setSubmitError(false);

    if (currentStep === 6) {
      resetForm({ values: initialValues, submitCount: 0 });
      setCurrentStep(1);
      return;
    }

    try {
      const data = {
        ...values,
        address: userAddress || "",
        originUrl: windowUrl,
        category: values?.category,
        formType: config?.platformTitle || "",
        marketingSource: marketingSource || "",
      };
      const response = await axios.post(
        "https://cn.chishtiglobal.ca/formconnector/sale2solddefault",
        data
      );
      if (response?.data?.result === 1) {
        window.scrollTo(0, 0);
        setCurrentStep(currentStep + 1);
        setSubmitError(false);
        setUserType(values?.category);
        setCurrentStep(currentStep + 1);

        if (isWhatsApp) {
          window.open(
            `https://api.whatsapp.com/send?phone=${
              config?.platformWhatsAppNumber
            }&amp;text=Hey ${config?.platformTitle}, My Name is ${
              values?.name || ""
            }. I am looking to Sell. Can you connect with me As soon as possible.`,
            "_blank"
          );
        }

        if (phoneBtnClick) {
          window.location.href = "tel:+16476490400";
        }
      } else {
        setSubmitError(true);
      }
    } catch (error) {
      setSubmitError(true);
      console.error(error);
    } finally {
      setIsWhatsApp(false);
      setPhoneBtnClick(false);
      setSubmitting(false);
      resetForm({ values, submitCount: 0 });
    }
  };

  return (
    <>
      {currentStep === 1 && (
        <div className="form_mainContainer">
          <div className="agent_profile d-flex align-items-center gap-3">
            <img
              src="https://config.assignmentsold.ca/Attachments/Newhomez-Agent-Profile.jpg"
              alt="Agent-Profle"
            />
            <div>
              <h3 className="agent_name m-0">
                {config?.platformTitle || "Sale2Sold"}
              </h3>
              <p className="agent_category">Listing Agent</p>
            </div>
          </div>
          <div className="form_container">
            <Formik
              initialValues={initialValues}
              validationSchema={SellerStep1Schema.shape({
                category: Yup.string().required("Category is required"),
              })}
              onSubmit={handleSubmit}
            >
              {({
                isSubmitting,
                errors,
                handleChange,
                handleBlur,
                values,
                submitCount,
                submitForm,
              }) => (
                <Form className="w-100 gap-3 mt-4 d-flex flex-column">
                  <AutoFocusError />
                  <FormFirstSlide
                    values={values}
                    errors={errors}
                    submitCount={submitCount}
                    handleChange={handleChange}
                    handleBlur={handleBlur}
                    isMultiPartForm={true}
                  />

                  {submitError && (
                    <p className="error_message m-0">
                      Error Submiting Form. Kindly submit again۔
                    </p>
                  )}

                  <div
                    className="w-100 d-flex align-item gap-3
                flex-wrap"
                  >
                    <button
                      type="submit"
                      className={`submit_button next_button ${
                        isSubmitting ? "disabled_btn" : ""
                      }`}
                      disabled={isSubmitting}
                    >
                      Next
                    </button>

                    <button
                      type="button"
                      className={`submit_button call_button 
                         ${isSubmitting ? "disabled_btn" : ""}`}
                      disabled={isSubmitting}
                      onClick={() => {
                        submitForm();
                        setPhoneBtnClick(true);
                      }}
                    >
                      Call
                    </button>
                  </div>

                  <button
                    className={`Send_btn whatsApp_btn  ${
                      isSubmitting ? "disabled_btn" : ""
                    }`}
                    id="whatsApp_btn"
                    type="button"
                    disabled={isSubmitting}
                    onClick={() => {
                      setIsWhatsApp(true);
                      submitForm();
                    }}
                  >
                    <img
                      src="https://config.assignmentsold.ca/attachments/newhomez-email/logos_whatsapp-icon.png"
                      alt="whatsapp_logo"
                    />
                    WhatsApp
                  </button>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      )}

      {currentStep === 2 && userType === "Seller" && (
        <StartSellingHomeForm isMultiPartForm={true} />
      )}
      {currentStep === 2 && userType === "Buyer" && (
        <StartBuyingHomeForm isMultiPartForm={true} />
      )}
      {currentStep === 2 && userType === "leadreferall" && (
        <LeadReferralRewardsGenericForm isMultiPartForm={true} />
      )}
      {currentStep === 2 && userType === "rent" && (
        <HomeToRentGenericForm isMultiPartForm={true} />
      )}
    </>
  );
};

export default MultipleSelectionForm;
